 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		13: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		13: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"commons","2":"3813a0b695fb4b74987297d52e352fc9f0512533","3":"875ea9739805bb53fa356a6c6aa8caa3ccd69097","4":"2b607f61fb466bdca4b31f7ec2f285b1417f3fb9","5":"536944b53b6c17f37f8af04243e74184c4aa845d","6":"d57276643d07fc8bb9202edb1957f3f154a012e9","7":"5e1085ff354e3bb6daefedf5e48fe6e4b1d8e564","8":"0cc20c5e5e5f1913c7b3dee64f6a383ed3d42411","9":"1d39aefc6cffaf7ffe73169ed1653337357f9c2e","10":"771d6599373c657452cbf1b4a7e550360826e426","11":"8e5974099a4f8437c03b235ee630755b4020c76c","12":"f9699d5023c242c0625cc561044313e382157c2e","14":"06f6b0c0","16":"c2ef2995","17":"component---src-pages-404-js","18":"component---src-pages-cases-2-cents-js","19":"component---src-pages-cases-cartovera-js","20":"component---src-pages-cases-chernomorsk-js","21":"component---src-pages-cases-city-portal-js","22":"component---src-pages-cases-crm-sap-integration-js","23":"component---src-pages-cases-design-js","24":"component---src-pages-cases-diasoft-js","25":"component---src-pages-cases-fcteam-js","26":"component---src-pages-cases-gud-job-js","27":"component---src-pages-cases-ilich-realty-js","28":"component---src-pages-cases-ingo-js","29":"component---src-pages-cases-iot-js","30":"component---src-pages-cases-js","31":"component---src-pages-cases-karpatska-chaika-js","32":"component---src-pages-cases-pickup-sport-js","33":"component---src-pages-cases-rzd-roads-js","34":"component---src-pages-cases-service-doc-js","35":"component---src-pages-cases-social-app-js","36":"component---src-pages-cases-utility-management-software-js","37":"component---src-pages-cases-video-conference-js","38":"component---src-pages-cases-videoconftool-js","39":"component---src-pages-cases-webrtc-js","40":"component---src-pages-cases-wikigrads-js","41":"component---src-pages-company-js","42":"component---src-pages-contact-js","43":"component---src-pages-estimate-js","44":"component---src-pages-expertise-cloud-solutions-js","45":"component---src-pages-expertise-cross-platform-js","46":"component---src-pages-expertise-internet-of-things-js","47":"component---src-pages-expertise-js","48":"component---src-pages-expertise-medical-app-development-services-js","49":"component---src-pages-expertise-rtc-js","50":"component---src-pages-expertise-startup-development-js","51":"component---src-pages-expertise-uiuxdesign-js","52":"component---src-pages-how-we-work-js","53":"component---src-pages-index-js","54":"component---src-pages-portfolio-js","55":"component---src-pages-privacy-policy-js","56":"component---src-pages-services-dedicatedteam-js","57":"component---src-pages-services-js","58":"component---src-pages-services-mobile-js","59":"component---src-pages-services-qa-js","60":"component---src-pages-services-startups-js","61":"component---src-pages-services-uiuxdesign-js","62":"component---src-pages-services-web-js","63":"component---src-pages-technology-aws-js","64":"component---src-pages-technology-iot-js","65":"component---src-pages-technology-js","66":"e8433949"}[chunkId]||chunkId) + "-" + {"0":"407fe62976dc5310c43e","1":"266c902db9b854240fd9","2":"255770167ac35df8f2a4","3":"8acc5bc049f7e47d3a59","4":"97399f82fc6132b0dc20","5":"5bc1dadb4498e674c642","6":"f0d83251b22c3dc243b0","7":"9ecc17a7eeb8809fbec4","8":"aa999acf640884af0fbe","9":"1949c0d111c0a69d7bd1","10":"699d743b265009228814","11":"a66d9162eb7565fa4da7","12":"4704639d071e811ace90","14":"5cc1f2cf54529ba53d52","16":"2d13c68d96407e15e2e1","17":"50e933ba3aecbecb80eb","18":"37e2c1bf1d2f602eea12","19":"be7280e3960c6c49c897","20":"f932c0732db2590abbdb","21":"5b82e58eb33f229015cf","22":"684d8cb533346b6b80d3","23":"d68efe2c77d3b6da1883","24":"fe11b7630e593c0257a2","25":"76c5615afc2155c6d3e7","26":"d7bcfbcf743209188f22","27":"c24c1ac5cade1f0e5848","28":"85991a303d4b5fe0fc09","29":"47b4f4fac11278fe657b","30":"a83ae84169bd75815dd8","31":"14f4a6b216803507943c","32":"443fe3922f24e2f56875","33":"7df9428dee88c38c2ebe","34":"317a1fdb51325315a7b8","35":"3b5d378fe7a4b044e43d","36":"d447500a91e9c118e3dd","37":"8b33c3697f2de9dcf2c6","38":"31e2c4b9b72c47d5e30d","39":"8557b884f7e070252e15","40":"841d28cf7e765c17701a","41":"1365d524d594b7d8087b","42":"dcf58cfc3f67a40057a1","43":"9b1e6ad1089c49dd4951","44":"0d862fc4367eb96750c9","45":"fb34e5314c7c08fae192","46":"8a2337a4d242eb025f19","47":"c99d08e79c8c87bc0df8","48":"7c4feb8064443682d224","49":"e038b2f65a3082a8197f","50":"e94a07fe2e551a31c97c","51":"c3cd7fcb91362fac2c7c","52":"a0f10a7cf9846401bd70","53":"0c0a89abc0671f288972","54":"e5c81755e1947481147c","55":"5bbbef905e583f585679","56":"35817d9f09acfeaea268","57":"0df56f7383b847ddabc7","58":"6ab6870596a4aa804b26","59":"54a4a56a56ffbd381047","60":"33ecf6d558d84be61325","61":"cc194e7d8c6cac00bab1","62":"35a964094c77716e8c2d","63":"d68f5d4b2682cc8abbdb","64":"1315d8375b78f58aaab3","65":"48412c1d2bbc1ce40e7e","66":"b72a264e64bda3964489","69":"5385b6bb11f56d71c049"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"commons","2":"3813a0b695fb4b74987297d52e352fc9f0512533","3":"875ea9739805bb53fa356a6c6aa8caa3ccd69097","4":"2b607f61fb466bdca4b31f7ec2f285b1417f3fb9","5":"536944b53b6c17f37f8af04243e74184c4aa845d","6":"d57276643d07fc8bb9202edb1957f3f154a012e9","7":"5e1085ff354e3bb6daefedf5e48fe6e4b1d8e564","8":"0cc20c5e5e5f1913c7b3dee64f6a383ed3d42411","9":"1d39aefc6cffaf7ffe73169ed1653337357f9c2e","10":"771d6599373c657452cbf1b4a7e550360826e426","11":"8e5974099a4f8437c03b235ee630755b4020c76c","12":"f9699d5023c242c0625cc561044313e382157c2e","14":"06f6b0c0","16":"c2ef2995","17":"component---src-pages-404-js","18":"component---src-pages-cases-2-cents-js","19":"component---src-pages-cases-cartovera-js","20":"component---src-pages-cases-chernomorsk-js","21":"component---src-pages-cases-city-portal-js","22":"component---src-pages-cases-crm-sap-integration-js","23":"component---src-pages-cases-design-js","24":"component---src-pages-cases-diasoft-js","25":"component---src-pages-cases-fcteam-js","26":"component---src-pages-cases-gud-job-js","27":"component---src-pages-cases-ilich-realty-js","28":"component---src-pages-cases-ingo-js","29":"component---src-pages-cases-iot-js","30":"component---src-pages-cases-js","31":"component---src-pages-cases-karpatska-chaika-js","32":"component---src-pages-cases-pickup-sport-js","33":"component---src-pages-cases-rzd-roads-js","34":"component---src-pages-cases-service-doc-js","35":"component---src-pages-cases-social-app-js","36":"component---src-pages-cases-utility-management-software-js","37":"component---src-pages-cases-video-conference-js","38":"component---src-pages-cases-videoconftool-js","39":"component---src-pages-cases-webrtc-js","40":"component---src-pages-cases-wikigrads-js","41":"component---src-pages-company-js","42":"component---src-pages-contact-js","43":"component---src-pages-estimate-js","44":"component---src-pages-expertise-cloud-solutions-js","45":"component---src-pages-expertise-cross-platform-js","46":"component---src-pages-expertise-internet-of-things-js","47":"component---src-pages-expertise-js","48":"component---src-pages-expertise-medical-app-development-services-js","49":"component---src-pages-expertise-rtc-js","50":"component---src-pages-expertise-startup-development-js","51":"component---src-pages-expertise-uiuxdesign-js","52":"component---src-pages-how-we-work-js","53":"component---src-pages-index-js","54":"component---src-pages-portfolio-js","55":"component---src-pages-privacy-policy-js","56":"component---src-pages-services-dedicatedteam-js","57":"component---src-pages-services-js","58":"component---src-pages-services-mobile-js","59":"component---src-pages-services-qa-js","60":"component---src-pages-services-startups-js","61":"component---src-pages-services-uiuxdesign-js","62":"component---src-pages-services-web-js","63":"component---src-pages-technology-aws-js","64":"component---src-pages-technology-iot-js","65":"component---src-pages-technology-js","66":"e8433949"}[chunkId]||chunkId) + "." + {"0":"afdaefde769af124f4f3","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c","59":"31d6cfe0d16ae931b73c","60":"31d6cfe0d16ae931b73c","61":"31d6cfe0d16ae931b73c","62":"31d6cfe0d16ae931b73c","63":"31d6cfe0d16ae931b73c","64":"31d6cfe0d16ae931b73c","65":"31d6cfe0d16ae931b73c","66":"31d6cfe0d16ae931b73c","69":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
